<div [formGroup]="form">
  <mat-select
    [formControlName]="controlName"
    [placeholder]="'CHOOSE' | translate"
  >
    <mat-option value="">{{'ALL' | translate}}</mat-option>
    <mat-option
      *ngFor="let type of filterTypes$ | async"
      [value]="type"
    >
      {{type}}
    </mat-option>
  </mat-select>
</div>
